import { withRouter } from "react-router-dom";

import QualityFilter from "../../../components/attribute_catalog/filters/quality_filter";

export default withRouter(QualityFilter);
